module.exports = __webpack_public_path__ + "img/erp.04506c44.png";